import { Link } from "react-router-dom";
import { Play, Star } from "lucide-react";

export const MovieCard = ({ movie, testid }) => {
  return (
    <Link
      to={`/movie/${movie.id}`}
      data-testid={testid || `movie-card-${movie.id}`}
      className="group block w-[150px] sm:w-[180px] shrink-0"
    >
      <div className="relative aspect-[2/3] overflow-hidden rounded-md border border-white/10 bg-[#111111]">
        {movie.poster_url ? (
          <img
            src={movie.poster_url}
            alt={movie.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="w-full h-full bg-[#1a1a1a]" />
        )}
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
        <div className="absolute top-2 left-2">
          <span className="font-mono-ui text-[10px] tracking-widest px-2 py-0.5 rounded border border-white/20 bg-black/50 text-[#00F0FF]">
            {movie.quality}
          </span>
        </div>
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="flex items-center justify-center w-11 h-11 rounded-full bg-[#00F0FF] text-black glow-cyan">
            <Play size={20} fill="currentColor" />
          </span>
        </div>
      </div>
      <div className="mt-2 px-0.5">
        <h3 className="font-heading text-sm font-medium text-white truncate">{movie.title}</h3>
        <div className="flex items-center gap-2 text-xs text-white/50 mt-0.5">
          <span>{movie.release_year}</span>
          <span className="w-1 h-1 rounded-full bg-white/30" />
          <span className="flex items-center gap-1"><Star size={11} className="text-[#00F0FF]" fill="currentColor" />{movie.rating?.toFixed(1)}</span>
        </div>
      </div>
    </Link>
  );
};
